import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  environment: 'preprod',
  operation: 'chatWithAgent',
  agentId: '',
  message: '',
  conversationId: '',
  streamResponse: false,
};

export default defaults;
